import React from "react";
import acceptSvg from "../../../static/images/check-circle-fill.svg";
import Image from "react-bootstrap/Image";

export default function AcceptIcon() {
  return <Image src={acceptSvg} />;
}
